/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import ObjectType from './ObjectType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper, updatePropertyOverride
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass

/**
 * <p>Java class for itemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="itemType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;choice&gt; &lt;element ref="{}queryItem"/&gt; &lt;element ref="{}namedSet"/&gt; &lt;element ref="{}filter"/&gt; &lt;element name="folder"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element ref="{}itemHierarchy"/&gt; &lt;element ref="{}calculation"/&gt; &lt;/choice&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ItemType extends MoserObject{

	queryItem = null;

	namedSet = null;

	filter = null;

	folder = null;

	itemHierarchy = null;

	calculation = null;



	/**
	 * A projectable item referring to an underlying source item (column, level, attribute, named set) or a calculation based on such items.
	 * @return {QueryItem} possible object is {@link QueryItem}
	 */
	getQueryItem() {
		return this.queryItem;
	}

	/**
	 * Sets the value of the queryItem property.
	 * @param {QueryItem} value allowed object is {@link QueryItem}
	 */
	setQueryItem(value) {
		var oldValue = this.queryItem;
		this.queryItem = value;
		this._setAndNotify(28, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 28, true);
		}
	}

	/**
	 * Gets the value of the namedSet property.
	 * @return {NamedSet} possible object is {@link NamedSet}
	 */
	getNamedSet() {
		return this.namedSet;
	}

	/**
	 * Sets the value of the namedSet property.
	 * @param {NamedSet} value allowed object is {@link NamedSet}
	 */
	setNamedSet(value) {
		var oldValue = this.namedSet;
		this.namedSet = value;
		this._setAndNotify(26, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 26, true);
		}
	}

	/**
	 * Selectable/dragable filters.
	 * @return {Filter} possible object is {@link Filter}
	 */
	getFilter() {
		return this.filter;
	}

	/**
	 * Sets the value of the filter property.
	 * @param {Filter} value allowed object is {@link Filter}
	 */
	setFilter(value) {
		var oldValue = this.filter;
		this.filter = value;
		this._setAndNotify(24, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 24, true);
		}
	}

	/**
	 * Gets the value of the folder property.
	 * @return {Folder} possible object is {@link ItemType.Folder}
	 */
	getFolder() {
		return this.folder;
	}

	/**
	 * Sets the value of the folder property.
	 * @param {Folder} value allowed object is {@link ItemType.Folder}
	 */
	setFolder(value) {
		var oldValue = this.folder;
		this.folder = value;
		this._setAndNotify(29, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 29, true);
		}
	}

	/**
	 * Gets the value of the itemHierarchy property.
	 * @return {ItemHierarchy} possible object is {@link ItemHierarchy}
	 */
	getItemHierarchy() {
		return this.itemHierarchy;
	}

	/**
	 * Sets the value of the itemHierarchy property.
	 * @param {ItemHierarchy} value allowed object is {@link ItemHierarchy}
	 */
	setItemHierarchy(value) {
		var oldValue = this.itemHierarchy;
		this.itemHierarchy = value;
		this._setAndNotify(27, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 27, true);
		}
	}

	/**
	 * Gets the value of the calculation property.
	 * @return {Calculation} possible object is {@link Calculation}
	 */
	getCalculation() {
		return this.calculation;
	}

	/**
	 * Sets the value of the calculation property.
	 * @param {Calculation} value allowed object is {@link Calculation}
	 */
	setCalculation(value) {
		var oldValue = this.calculation;
		this.calculation = value;
		this._setAndNotify(25, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 25, true);
		}
	}

	/**
	 * Creates a new instance of <code>ItemType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ItemType</code> object from.
	 * @return {ItemType} an object of type <code>ItemType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createItemType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ItemType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createQueryItem().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 28, "queryItem", clazz));
		if (factory) {
			clazz = factory.createNamedSet().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 26, "namedSet", clazz));
		if (factory) {
			clazz = factory.createFilter().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 24, "filter", clazz));
		if (factory) {
			clazz = factory.createItemTypeFolder().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 29, "folder", clazz));
		if (factory) {
			clazz = factory.createItemHierarchy().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 27, "itemHierarchy", clazz));
		if (factory) {
			clazz = factory.createCalculation().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 25, "calculation", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 24:
			this.setFilter((value));
			break;
		case 25:
			this.setCalculation((value));
			break;
		case 26:
			this.setNamedSet((value));
			break;
		case 27:
			this.setItemHierarchy((value));
			break;
		case 28:
			this.setQueryItem((value));
			break;
		case 29:
			this.setFolder((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 24:
			return this.getFilter();
		case 25:
			return this.getCalculation();
		case 26:
			return this.getNamedSet();
		case 27:
			return this.getItemHierarchy();
		case 28:
			return this.getQueryItem();
		case 29:
			return this.getFolder();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 24:
			return this.getFilter();
		case 25:
			return this.getCalculation();
		case 26:
			return this.getNamedSet();
		case 27:
			return this.getItemHierarchy();
		case 28:
			return this.getQueryItem();
		case 29:
			return this.getFolder();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
ItemType.Folder = class extends ObjectType{

	item = null;



	/**
	 * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	 */
	getItem() {
		if (!this.item) {
			this.item = [];
		}
		return this.item;
	}

	/**
	 * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	 */
	basicGetItem() {
		return this.item;
	}

	/**
	 * Creates a new instance of <code>Folder</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Folder</code> object from.
	 * @return {Folder} an object of type <code>Folder</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createItemTypeFolder();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addItemAt(position, item) {
		this._addAtAndNotify(this.getItem(), position, item, 3, true, false);
		var qi = item.getQueryItem();
		if (qi) {
			MoserObject.updatePropertyOverride(qi, this, 28, true);
		}
		var hierarchy = item.getItemHierarchy();
		if (hierarchy) {
			MoserObject.updatePropertyOverride(hierarchy, this, 27, true);
		}
		var namedSet = item.getNamedSet();
		if (namedSet) {
			MoserObject.updatePropertyOverride(namedSet, this, 26, true);
		}
		var filter = item.getFilter();
		if (filter) {
			MoserObject.updatePropertyOverride(filter, this, 24, true);
		}
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addItem(item) {
		this.addItemAt(this.getItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeItemAt(position) {
		this._removeAtAndNotify(this.getItem(), position, 3, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeItem(item) {
		var i = this.getItem().indexOf(item);
		if (i >= 0) {
			this.removeItemAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Folder";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createItemType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 3, "item", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 3:
			this.item = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 3:
			return this.getItem();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 3:
			return this.basicGetItem();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 3:
			this.addItemAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 3:
			this.addItem((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 3:
			this.removeItemAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 3:
			this.removeItem((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ItemType.js